import axios from "axios";
import { env } from "../../env";
import { RPC_FAQ_ENDPOINTS } from "../endpoints";

const BASE_URL = env.REACT_APP_CLIENT_API_URL || "";

const STORAGE_KEY_PREFIX = "faq_";

export const getFaqStorageKey = (language) => `${STORAGE_KEY_PREFIX}${language}`;

const normalizeFaqList = (data) => {
    const list = Array.isArray(data) ? data : (data?.Data || data?.data || []);
    return list
        .map((item) => ({
            id: item?.Id || item?.id,
            q: item?.Question || item?.question || "",
            a: item?.Answer || item?.answer || "",
            order: item?.Order || item?.order || 0,
        }))
        .filter((item) => item.q)
        .sort((a, b) => a.order - b.order);
};

export const getFaqList = async (language = "en") => {
    const response = await axios.post(
        `${BASE_URL}${RPC_FAQ_ENDPOINTS.GET_FAQ_LIST}`,
        { _language: language },
        { headers: { "Content-Type": "application/json" } }
    );
    return normalizeFaqList(response?.data);
};

export const fetchAndCacheFaq = async (language = "en") => {
    const items = await getFaqList(language);
    if (items.length) {
        sessionStorage.setItem(getFaqStorageKey(language), JSON.stringify(items));
    }
    return items;
};

export const getCachedFaq = (language = "en") => {
    try {
        const raw = sessionStorage.getItem(getFaqStorageKey(language));
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};
